/**
 * Splits Shopify's dual currency price into a primary and a secondary part.
 *
 * Shopify renders BGN markets as "€15,33 (29.98 лв)" — a single string, so the
 * two halves cannot be styled apart. This rewrites the node as
 * "<primary>€15,33</primary><secondary>≈ 29.98 лв</secondary>" and re-runs
 * whenever the theme replaces the price on a variant change.
 */
(function () {
  const selectors = {
    price: '.product-single__details [data-product-price]'
  };

  const classes = {
    primary: 'product__price--primary',
    secondary: 'product__price--secondary'
  };

  const DUAL_PATTERN = /^\s*(.+?)\s*\(\s*(.+?)\s*\)\s*$/;

  class DualPrice {
    constructor(element) {
      this.element = element;
      this.observer = new MutationObserver(this.onMutation.bind(this));

      this.format();
      this.observe();
    }

    observe() {
      this.observer.observe(this.element, {
        childList: true,
        characterData: true,
        subtree: true
      });
    }

    onMutation() {
      this.observer.disconnect();
      this.format();
      this.observe();
    }

    /**
     * Rebuild the price markup, leaving single currency prices untouched.
     */
    format() {
      if (this.element.querySelector(`.${classes.primary}`)) return;

      const raw = this.element.textContent.trim();
      const parts = raw.match(DUAL_PATTERN);

      if (!parts) return;

      const [, primary, secondary] = parts;

      this.element.innerHTML =
        `<span class="${classes.primary}">${primary}</span>` +
        `<span class="${classes.secondary}">≈ ${secondary}</span>`;
    }
  }

  const init = () => {
    document.querySelectorAll(selectors.price).forEach((element) => {
      if (element.dataset.dualPriceReady) return;

      element.dataset.dualPriceReady = 'true';
      new DualPrice(element);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
